import { useFormik } from "formik";
import React from "react";
import {
  BsBookmarkStarFill,
  BsFillPersonFill,
  BsPencil,
  BsPlus,
  BsRobot,
  BsUpload,
} from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import orgApi from "../../../api/org_api";
import {
  Breadcrumb,
  Button,
  CustomInput,
  IconButton,
  Label,
  Modal,
  SearchableDropdown,
  Text,
} from "../../../component/common";
import { CloseModal } from "../../../component/Layout/CloseModal";
import SwitchComp from "../../../component/Switch";
import S from "../../../Services/GeneralServices";
import { Style } from "../../../utils/Style";
import SelectFavourites from "../UploadJd/SelectFavourites";
import SelectGroups from "../UploadJd/SelectGroup";

type JdRoundsProps = { setLoading: Function };

const JdRounds = ({ setLoading }: JdRoundsProps) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [showAddRoundModal, setShowAddRoundModal] = React.useState(false);
  const [uploadResumeModal, setUploadResumeModal] = React.useState(false);
  const [addInterviewerModal, setAddInterviewerModal] = React.useState(false);
  const [addGroupModal, setAddGroupModal] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState<File[]>([]);
  const [resumeType, setResumeType] = React.useState([] as any);
  const [roundType, setRoundType] = React.useState("add");
  const [fileError, setfileError] = React.useState("");
  const [jdDetail, setJdDetail] = React.useState();
  const [roundId, setRoundId] = React.useState("");
  const [roundMode, setRoundMode] = React.useState("Manual");
  const [intType, setIntType] = React.useState("other");
  const [inhouse, setInhouse] = React.useState(true);
  const [external, setExternal] = React.useState(false);
  const [market, setMarket] = React.useState(true);
  const [favCount, setFavCount] = React.useState(0);
  const [fromType, setFromType] = React.useState("");
  const [isDisabled, setisDisabled] = React.useState(false);
  const [groups, setgroups] = React.useState([] as any);
  // const goBack = () => navigate(-1);
  const org = JSON.parse(localStorage.getItem("user__details")?.toString()!);
  const orgId = org.id;
  const masterId = org.master_id !== null ? org.master_id : org.id;

  React.useEffect(() => {}, [selectedFile]);
  React.useEffect(() => {
    fetchJdDetails();
  }, []);

  const formik = useFormik({
    initialValues: { name: "", type: "", mode: "Manual" },
    validationSchema: Yup.object({
      name: Yup.string().required("Round name is required"),
      type: Yup.string().required("Select Type"),
    }),
    validateOnBlur: true,
    onSubmit: async (values) => {
      if (intType === "other") {
        if (!inhouse && !external && !market) {
          toast("Select Interviewers");
          return;
        }
      } else {
        setInhouse(false);
        setExternal(false);
        setMarket(false);
      }
      setLoading(true);
      setisDisabled(true);
      if (roundType === "add") {
        var reqData = {
          name: values.name,
          type: values.type,
          mode: values.mode,
          level: jdDetail ? (jdDetail["round"] as any).length : 1,
          post_id: id,
          fav: intType === "fav" ? true : false,
          house: intType !== "fav" && intType !== "group" ? inhouse : false,
          market: intType !== "fav" && intType !== "group" ? market : false,
          external: intType !== "fav" && intType !== "group" ? external : false,
          group: intType === "group" ? true : false,
          i_group: groups,
        };
        const res = await orgApi.addRound(reqData);
        if (res.data.success) {
          setShowAddRoundModal(false);
          toast(res.data.msg);
          fetchJdDetails();
        } else {
          toast(res.data.msg);
        }
        setisDisabled(false);
        setLoading(false);
      } else if (roundType === "edit") {
        var reqData1 = {
          name: values.name,
          type: values.type,
          mode: values.mode,
          round_id: roundId,
          fav: intType === "fav" ? true : false,
          house: intType !== "fav" && intType !== "group" ? inhouse : false,
          market: intType !== "fav" && intType !== "group" ? market : false,
          external: intType !== "fav" && intType !== "group" ? external : false,
          group: intType === "group" ? true : false,
        };
        const res = await orgApi.editRound(reqData1);
        if (res.data.success) {
          setShowAddRoundModal(false);
          toast(res.data.msg);
          fetchJdDetails();
        } else {
          toast(res.data.msg);
        }
        setisDisabled(false);
        setLoading(false);
      }
    },
  });

  const fetchJdDetails = async () => {
    setLoading(true);
    if (
      S.getOrgDomain() === "sightspectrum.com" ||
      S.getOrgDomain() === "vegaintellisoft.com" ||
      S.getOrgDomain() === "nam-it.com" ||
      S.getOrgDomain() === "infinitisoftware.net"
    ) {
      setMarket(false);
    }
    const res = await orgApi.getSingleJdDetail(id);
    if (res.data.success) {
      res.data.post.round.length !== 0 &&
        res.data.post.round.push({ isNew: true });
      setJdDetail(res.data.post);
      setFavCount(res.data.post.fav_count);
    } else {
      setJdDetail(undefined);
    }
    setLoading(false);
  };
  const openUploadResume = () => {
    setSelectedFile([]);
    setUploadResumeModal(true);
  };
  const addRound = () => {
    formik.values.name = "";
    formik.values.type = "";
    formik.values.mode = "Manual";
    setRoundMode("Manual");
    setRoundId("");
    formik.resetForm();
    setRoundType("add");
    setIntType("other");
    setInhouse(true);
    setMarket(true);
    if (
      S.getOrgDomain() === "sightspectrum.com" ||
      S.getOrgDomain() === "vegaintellisoft.com" ||
      S.getOrgDomain() === "nam-it.com" ||
      S.getOrgDomain() === "infinitisoftware.net"
    ) {
      setMarket(false);
    }
    setShowAddRoundModal(true);
  };
  const editRound = (val: any) => {
    formik.setValues({
      name: val.name || "",
      type: val.type || "",
      mode: val.mode || "",
    });
    setRoundMode(val.mode);
    setRoundId(val.id);
    setExternal(val.external);
    setInhouse(val.house);
    setMarket(val.market);
    if (val.external || val.house || val.market) {
      setIntType("other");
    } else if (val.group) {
      setIntType("group");
    } else {
      setIntType("fav");
    }
    setRoundType("edit");
    setShowAddRoundModal(true);
  };

  const handleImageChange = async (event: any) => {
    const ds: any = await S.handleUploadResume(event.target.files);
    setfileError(ds["error"]);
    setSelectedFile(ds["resumefiles"]);
    setResumeType(ds["resumeType"]);
  };
  const getDate = (dateStr: string) => {
    const formattedDate = convert(dateStr!);
    return formattedDate;
  };
  function convert(str: string) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  const getSubscription = async (resLen: any, roundTag: any) => {
    setLoading(true);
    let userInfo = JSON.parse(
      localStorage.getItem("user__details")?.toString()!,
    );
    let orgId = userInfo.master_id !== null ? userInfo.master_id : userInfo.id;
    const res = await orgApi.getSubs(orgId);
    if (res.data.success) {
      setLoading(false);
      let subscription = res.data.org;
      if (roundTag === "external" && subscription.e_available < resLen) {
        toast(
          `You can upload a maximum of ${subscription.e_available} resumes.`,
        );
        return false;
      } else if (roundTag === "internal" && subscription.i_available < resLen) {
        toast(
          `You can upload a maximum of ${subscription.i_available} resumes.`,
        );
        return false;
      } else if (roundTag === "combination") {
        let min =
          subscription.i_available >= subscription.e_available
            ? subscription.e_available
            : subscription.i_available;
        if (min < resLen) {
          toast(`You can upload a maximum of ${min} resumes.`);
          return false;
        }
      }
    } else {
      setLoading(false);
      return true;
    }
    return true;
  };
  const uploadResume = async () => {
    let roundTag = "";
    if (jdDetail) {
      let d = jdDetail["round"][0];
      if (
        d["fav"] ||
        (d["house"] && d["market"] && !d["external"]) ||
        (!d["house"] && d["market"] && d["external"]) ||
        (d["house"] && d["market"] && d["external"])
      ) {
        roundTag = "combination";
      } else if (!d["house"] && d["market"] && !d["external"]) {
        roundTag = "external";
      } else if (
        (d["house"] && !d["market"] && !d["external"]) ||
        (!d["house"] && !d["market"] && d["external"]) ||
        (d["house"] && !d["market"] && d["external"])
      ) {
        roundTag = "internal";
      }
    }
    let scope = [] as any;
    resumeType.forEach((r_type: any) => {
      scope.push({ type: r_type ? "sit" : "others" });
    });
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formData = new FormData();
    formData.append("tz", timezone);
    formData.append("org_id", orgId);
    formData.append("master_id", masterId);
    formData.append("tag", roundTag);
    formData.append("scope", JSON.stringify(scope));
    let mv: Boolean | undefined = await getSubscription(
      selectedFile.length,
      roundTag,
    );
    if (!mv) {
      return;
    }
    for (let k = 0; k < selectedFile.length; k++) {
      formData.append("resume", selectedFile[k]);
    }
    setisDisabled(true);
    setLoading(true);
    const res = await orgApi.uploadCandidate(formData, id);
    if (res.data.success === true) {
      toast(res.data.msg);
      fetchJdDetails();
      setUploadResumeModal(false);
    } else {
      toast(res.data.msg);
    }
    setisDisabled(false);
    setLoading(false);
  };
  const removeResume = async (index: number) => {
    setSelectedFile((prevState) => prevState.filter((_, ind) => ind !== index));
    setResumeType((prevState: any) =>
      prevState.filter((_: any, ind: number) => ind !== index),
    );
  };
  const setCallback = () => {
    fetchJdDetails();
    setAddInterviewerModal(false);
  };
  const setGroupCallback = (grp: any) => {
    if (roundType === "edit") {
      setAddGroupModal(false);
    } else {
      setgroups(grp);
      setAddGroupModal(false);
    }
  };
  const setfromType = (type: any) => {
    setFromType(type);
    setAddInterviewerModal(true);
  };
  const intGroup = () => {
    setAddGroupModal(true);
  };
  // const gotoInterviewerList = () =>
  //   navigate("/select_interviewers/" + id + "/" + null + "/rounds/interviewer");
  const gotoCandidateList = (
    roundId: any,
    level: number,
    roundIndex: number,
    // status: any
  ) => {
    var nextRound = false;
    if (jdDetail && (jdDetail["round"] as any).length - 1 > roundIndex + 1) {
      nextRound = true;
    }
    navigate("/candidate_list/" + id + "/" + roundId + "/" + level, {
      state: { nextRound: nextRound },
    });
  };

  return (
    <>
      {showAddRoundModal && (
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="fixed inset-0 w-full h-full bg-black opacity-50"></div>
          <div className="flex items-center min-h-screen px-4 py-8">
            <div className="relative w-full max-w-lg p-4 mx-auto bg-white shadow-lg rounded-sm rounded-br-3xl">
              <div className="sm:flex">
                <div className="mt-1 text-center sm:text-left w-full">
                  <div className="flex items-center justify-between border-b">
                    <h6 className="text-sm font-bold text-gray-800 mb-2">
                      {roundType === "add" ? "Add" : "Edit"} Round
                    </h6>
                  </div>
                  <div className="mt-1">
                    <form onSubmit={formik.handleSubmit}>
                      <div className="grid gap-4 grid-cols-1">
                        <div className="px-2">
                          <div className="flex flex-row item-center justify-start gap-5">
                            <div className="flex items-center gap-2">
                              <input
                                checked={roundMode === "Manual"}
                                id="default-radio-1"
                                type="radio"
                                name="default-radio"
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                                onChange={() => {
                                  formik.values.mode = "Manual";
                                  setRoundMode("Manual");
                                }}
                              ></input>
                              <label className={Style.label}>Manual</label>
                            </div>
                            <div className="flex items-center gap-2 disabled-div">
                              <input
                                checked={roundMode === "AI"}
                                id="default-radio-2"
                                type="radio"
                                name="default-radio"
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                                onChange={() => {
                                  formik.values.mode = "AI";
                                  setRoundMode("AI");
                                }}
                              ></input>
                              <label className={Style.label}>AI</label>
                            </div>
                          </div>
                        </div>
                        <div className="flex gap-2 px-2">
                          <CustomInput
                            label="Round Name"
                            type="text"
                            name="name"
                            value={formik.values.name}
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            placeholder="Round Name"
                            isError={
                              !!formik.touched.name && !!formik.errors.name
                            }
                          />
                          <SearchableDropdown
                            options={[
                              { label: "Technical", value: "Technical" },
                              { label: "HR", value: "HR" },
                            ]}
                            value={formik.values.type}
                            onChange={(selectedOption) => {
                              formik.setFieldValue(
                                "type",
                                selectedOption.value,
                              );
                            }}
                            label="Type"
                            isError={
                              !!formik.touched.type && !!formik.errors.type
                            }
                          />
                        </div>
                        <div className="flex flex-col gap-4 px-2">
                          <div className="flex flex-col gap-2">
                            <Label text="Interviewer" />
                            <div className="flex flex-row item-center justify-between  gap-5 grid grid-cols-3">
                              <div className="flex items-center gap-2">
                                <input
                                  checked={intType === "other"}
                                  id="default-radio-2"
                                  type="radio"
                                  value={intType}
                                  name="default-radio-2"
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                                  onChange={() => setIntType("other")}
                                ></input>
                                <label className="text-gray-500 text-xs font-normal">
                                  Interviewer type
                                </label>
                              </div>
                              <div className="flex items-center gap-2">
                                <input
                                  checked={intType === "fav"}
                                  id="default-radio-3"
                                  value={intType}
                                  type="radio"
                                  name="default-radio-3"
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                                  onChange={() => setIntType("fav")}
                                ></input>
                                <label className="text-gray-500 text-xs font-normal">
                                  Favourites
                                </label>
                              </div>
                              <div className="flex items-center gap-2">
                                <input
                                  checked={intType === "group"}
                                  id="default-radio-3"
                                  value={intType}
                                  type="radio"
                                  name="default-radio-3"
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                                  onChange={() => setIntType("group")}
                                ></input>
                                <label className="text-gray-500 text-xs font-normal">
                                  Group
                                </label>
                              </div>
                            </div>
                          </div>
                          {intType === "other" && (
                            <div className="flex flex-col items-start">
                              <div
                                className="inline-flex items-center"
                                onClick={() => setInhouse(!inhouse)}
                              >
                                <label className="relative flex items-center p-3 rounded-full cursor-pointer">
                                  <input
                                    type="checkbox"
                                    checked={inhouse ? true : false}
                                    className="before:content[''] peer relative h-3 w-3 cursor-pointer appearance-none rounded-sm border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:bg-gray-600 hover:before:opacity-10"
                                    id="check"
                                  />
                                  <span className="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-3.5 w-3.5"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                      stroke="currentColor"
                                      stroke-width="1"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clip-rule="evenodd"
                                      ></path>
                                    </svg>
                                  </span>
                                </label>
                                <label
                                  className="mt-px font-light text-gray-700 text-xs cursor-pointer select-none"
                                  htmlFor="check"
                                >
                                  In-House
                                </label>
                              </div>
                              <div
                                className="inline-flex items-center"
                                onClick={() => setExternal(!external)}
                              >
                                <label className="relative flex items-center p-3 rounded-full cursor-pointer">
                                  <input
                                    type="checkbox"
                                    checked={external ? true : false}
                                    className="before:content[''] peer relative h-3 w-3 cursor-pointer appearance-none rounded-sm border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:bg-gray-600 hover:before:opacity-10"
                                    id="check1"
                                  />
                                  <span className="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-3.5 w-3.5"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                      stroke="currentColor"
                                      stroke-width="1"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clip-rule="evenodd"
                                      ></path>
                                    </svg>
                                  </span>
                                </label>
                                <label
                                  className="mt-px font-light text-gray-700 text-xs cursor-pointer select-none"
                                  htmlFor="check1"
                                >
                                  External
                                </label>
                              </div>
                              <div
                                className="inline-flex items-center"
                                onClick={() => setMarket(!market)}
                              >
                                <label className="relative flex items-center p-3 rounded-full cursor-pointer">
                                  <input
                                    type="checkbox"
                                    checked={market ? true : false}
                                    className="before:content[''] peer relative h-3 w-3 cursor-pointer appearance-none rounded-sm border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:bg-gray-600 hover:before:opacity-10"
                                    id="check2"
                                  />
                                  <span className="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-3.5 w-3.5"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                      stroke="currentColor"
                                      stroke-width="1"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clip-rule="evenodd"
                                      ></path>
                                    </svg>
                                  </span>
                                </label>
                                <label
                                  className="mt-px font-light text-gray-700 text-xs cursor-pointer select-none"
                                  htmlFor="check2"
                                >
                                  Market place
                                </label>
                              </div>
                            </div>
                          )}
                          {intType === "fav" && (
                            <>
                              <div className="gap-2 flex items-center mt-4 justify-center">
                                <button
                                  type="button"
                                  className=" py-1.5 px-2 text-gray-500 outline-none border text-xs rounded w-1/3 flex flex-row items-center justify-center gap-2"
                                  onClick={() => setfromType("viewFav")}
                                >
                                  <span className="flex items-center gap-2">
                                    <BsBookmarkStarFill /> {favCount}{" "}
                                  </span>
                                  Favourites
                                </button>
                                <button
                                  type="button"
                                  className={
                                    " py-1.5 px-2 text-gray-500 outline-none border text-xs rounded w-1/3 flex flex-row items-center justify-center gap-2"
                                  }
                                  onClick={() => setfromType("addFav")}
                                >
                                  <BsPlus />
                                  Add Favourites
                                </button>
                              </div>
                            </>
                          )}
                          {intType === "group" && (
                            <>
                              <div className=" flex justify-center mt-4 ">
                                <button
                                  type="button"
                                  className={
                                    "py-1.5 px-2 text-gray-500 outline-none border text-xs rounded w-1/3 flex flex-row items-center justify-center gap-2"
                                  }
                                  onClick={() => intGroup()}
                                >
                                  <BsPlus />
                                  {roundType === "add" && groups.length}{" "}
                                  Interviewer Group
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <div className=" gap-2 mt-3 flex justify-end">
                        <button
                          className=" mt-2 py-1.5 px-2.5 text-gray-800 outline-none border bg-gray-100 text-xs rounded-md"
                          onClick={() => setShowAddRoundModal(false)}
                          type="button"
                        >
                          Cancel
                        </button>
                        <button
                          className={
                            !isDisabled
                              ? "mt-2 py-1.5 px-2.5 text-white button-primary outline-none text-xs rounded-md"
                              : "mt-2 py-1.5 px-2.5 text-white button-primary-tint outline-none text-xs rounded-md"
                          }
                          type="submit"
                          disabled={isDisabled}
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {addInterviewerModal && (
        // <div className="fixed inset-0 z-10 overflow-y-auto">
        //   <div className="fixed inset-0 w-full h-full bg-black opacity-50"></div>
        //   <div className="flex items-center max-h-screen px-1 py-1">
        //     <div className="relative w-full max-w-full p-1 mx-auto bg-white shadow-lg">
        //       <div className="sm:flex">
        //         <div className="mt-1 text-center sm:text-left w-full">
        //           <div className="flex items-center justify-between border-b">
        //             <h6 className="text-sm font-bold text-gray-800 mb-2">
        //               Add Favourite Interviewers
        //             </h6>
        //           </div>
        //           <div className="mt-1">
        //             <SelectFavourites
        //               callBack={setCallback}
        //               postId={id}
        //               from_type={fromType}
        //             />
        //           </div>
        //         </div>
        //       </div>
        //     </div>
        //   </div>
        // </div>
        <Modal
          size="4xl"
          isOpen={addInterviewerModal}
          title="Add Favourite Interviewers"
          // onClose={() => setAddInterviewerModal(false)}
          children={
            <SelectFavourites
              callBack={setCallback}
              postId={id}
              from_type={fromType}
            />
          }
        />
      )}
      {uploadResumeModal && (
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="fixed inset-0 w-full h-full bg-black opacity-50"></div>
          <div className="flex items-center  px-4 py-8">
            <div className="relative w-full max-w-lg p-4 mx-auto bg-white shadow-lg rounded-sm rounded-br-3xl">
              <div className="sm:flex">
                <div className="mt-1 text-center sm:text-left w-full">
                  <div className="flex items-center justify-between border-b">
                    <h6 className="text-sm font-bold text-gray-800 mb-2">
                      Upload Resume
                    </h6>
                  </div>
                  <div className="mt-1">
                    <form className="max-w-lg mx-auto mt-4">
                      <div className="flex items-center w-full border-primary rounded ">
                        <div className="cursor-pointer w-full">
                          <label className="cursor-pointer w-full flex justify-start">
                            {selectedFile.length > 0 && (
                              <div className="flex justify-center items-center border-r overflow-hidden font-semibold text-xs p-2 bg-primary text-white w-1/4">
                                <BsUpload color="white" size={10} /> &nbsp;
                                Change
                              </div>
                            )}
                            {selectedFile.length === 0 && (
                              <div className="flex justify-center items-center border-r  overflow-hidden font-semibold text-xs p-2 bg-primary text-white w-1/4">
                                <BsUpload color="white" size={10} /> &nbsp;
                                Upload
                              </div>
                            )}
                            <div className="flex justify-start items-center w-2/4 ">
                              &nbsp;
                              {selectedFile.length !== 0 && (
                                <div className="text-sm px-3 text-gray-400 truncate">
                                  {selectedFile[0]?.name}
                                </div>
                              )}
                              <input
                                type="file"
                                className="hidden"
                                multiple={true}
                                onChange={handleImageChange}
                              ></input>
                            </div>
                          </label>
                        </div>
                      </div>
                      {fileError !== "" && (
                        <div className="error mb-2">{fileError}</div>
                      )}
                      <div
                        className="mt-1 text-xs text-gray-500"
                        id="user_avatar_help"
                      >
                        {"Supported formats: .pdf, .docx; Maximum size: 3MB"}
                      </div>
                      {selectedFile.length > 0 && (
                        <>
                          {selectedFile.map((resume: any, index: number) => (
                            <>
                              <div
                                className="flex flex-row justify-between my-2"
                                key={index}
                              >
                                <div className="flex flex-row items-center gap-2 justify-start">
                                  <SwitchComp
                                    resumeType={resumeType}
                                    setResumeType={setResumeType}
                                    index={index}
                                    on={"Auto"}
                                    off={"Manual"}
                                  ></SwitchComp>
                                  <span className=" text-sm font-medium text-gray-600">
                                    {resume.name}
                                  </span>
                                </div>
                                <button
                                  onClick={() => removeResume(index)}
                                  type="button"
                                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                >
                                  <CloseModal />
                                </button>
                              </div>
                            </>
                          ))}
                        </>
                      )}
                    </form>

                    <div className=" gap-2 mt-3 sm:flex md:flex lg:flex flex-row justify-end">
                      <button
                        className=" mt-2 py-1 px-2.5 text-gray-800 outline-none border text-sm rounded-md"
                        onClick={() => setUploadResumeModal(false)}
                      >
                        Cancel
                      </button>
                      <button
                        className={
                          selectedFile.length > 0
                            ? " button-primary mt-2 py-1 px-2.5 text-white outline-none text-sm rounded-md"
                            : " bg-indigo-300 mt-2 py-1 px-2.5 text-white outline-none text-sm rounded-md"
                        }
                        onClick={() => uploadResume()}
                        disabled={
                          selectedFile.length > 0 && !isDisabled ? false : true
                        }
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {addGroupModal && (
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="fixed inset-0 w-full h-full bg-black opacity-50"></div>
          <div className="flex items-center max-h-screen px-1 py-1">
            <div className="relative w-full max-w-4xl p-1 mx-auto bg-white shadow-lg">
              <div className="sm:flex">
                <div className="mt-1 text-center sm:text-left w-full p-3">
                  <div className="flex items-center justify-between border-b">
                    <h6 className="text-sm font-bold text-gray-800 mb-2 py-1">
                      Add Interviewer Groups
                    </h6>
                  </div>
                  <div className="mt-1">
                    <SelectGroups
                      callBack={setGroupCallback}
                      selectedGroups={groups}
                      roundId={roundType === "add" ? null : roundId}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {jdDetail && (
        <div className=" h-[calc(100vh-100px)] 2xl:h-[calc(100vh-120px)] w-full">
          <div className="flex flex-col space-y-3">
            <div className="flex items-center justify-between">
              <Breadcrumb
                items={[
                  { text: "Job Description", href: "/job_description" },
                  { text: "Upload Candidates", isActive: true },
                ]}
              />
              <Button
                onClick={() => openUploadResume()}
                leftIcon={BsUpload}
                text=" Upload Candidates"
              />
            </div>

            <div className="bg-gray-100 border h-16 w-full no-scrollbar overflow-x-auto border-gray-200 rounded-lg shadow-sm px-2 py-2">
              <div className="flex  items-center justify-between gap-2">
                <div className="min-w-[200px]">
                  <p className="text-sm font-bold text-gray-900 truncate">
                    {jdDetail["job_title"]}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">Job Title</p>
                </div>
                <div className="min-w-[200px]">
                  <p className="text-sm font-semibold text-gray-800 truncate">
                    {jdDetail["profile"]}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">Profile</p>
                </div>
                <div className="min-w-[200px]">
                  <p className="text-sm font-mono font-semibold text-gray-700">
                    {jdDetail["unique_id"]}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">Job ID</p>
                </div>
                <div className="min-w-[200px]">
                  <p className="text-sm font-semibold text-gray-800">
                    {getDate(jdDetail["post_validity"])}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">Valid Until</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1  md:grid-cols-2 overflow-scroll  h-[calc(100vh-200px)] 2xl:h-[calc(100vh-220px)] no-scrollbar  lg:grid-cols-4 gap-3">
              {(jdDetail["round"] as any).map((value: any, index: number) => (
                <React.Fragment key={value.id || index}>
                  {(jdDetail["round"] as any).length - 1 !== index ? (
                    <div
                      className="bg-white border border-gray-200 rounded-lg py-2 px-3 h-64 flex flex-col gap-2 hover:shadow-md transition-shadow cursor-pointer"
                      onClick={() =>
                        gotoCandidateList(value.id, value.level, index)
                      }
                    >
                      <div className="flex items-center justify-between gap-2 border-b border-gray-100 ">
                        <div className="flex items-center gap-2">
                          <div className="mt-0.5 text-lg text-blue-600 border border-gray-200 rounded-full p-2">
                            {value.mode === "Manual" && <BsFillPersonFill />}
                            {value.mode === "AI" && <BsRobot />}
                          </div>
                          <div className="flex flex-col gap-1 flex-1">
                            <Text className="text-sm font-semibold text-gray-900 truncate">
                              {value.name}
                            </Text>
                            <Text className="text-xs text-gray-500 truncate">
                              {value.type}
                            </Text>
                          </div>
                        </div>

                        <IconButton
                          onClick={() => {
                            editRound(value);
                          }}
                          icon={<BsPencil size={12} />}
                        />
                      </div>
                      <div className="flex flex-col gap-2 flex-1">
                        {[
                          { label: "New", value: value.new, status: "New" },
                          {
                            label: "Scheduled",
                            value: value.scheduled,
                            status: "Scheduled",
                          },
                          {
                            label: "Completed",
                            value: value.completed,
                            status: "Completed",
                          },
                          {
                            label: "Selected",
                            value: value.selected,
                            status: "Selected",
                          },
                        ].map((item, idx) => (
                          <div
                            key={idx}
                            className="flex items-center justify-between text-xs hover:bg-gray-50 px-1 py-0.5 rounded transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              gotoCandidateList(value.id, value.level, index);
                            }}
                          >
                            <span className="text-gray-500 font-normal w-20">
                              {item.label}:
                            </span>
                            <span className="font-semibold text-gray-900">
                              {item.value}
                            </span>
                          </div>
                        ))}
                      </div>

                      {/* Interviewers and total count section */}
                      <div className="flex items-end justify-between pt-2 border-t border-gray-100">
                        <div className="flex flex-col gap-0.5">
                          <h4 className="text-xs font-semibold text-gray-700">
                            Interviewers
                          </h4>
                          <div className="space-y-0.5">
                            {value.fav && (
                              <p className="text-xs text-gray-500">
                                Favourites
                              </p>
                            )}
                            {value.group && (
                              <p className="text-xs text-gray-500">Groups</p>
                            )}
                            {value.external && (
                              <p className="text-xs text-gray-500">External</p>
                            )}
                            {value.house && (
                              <p className="text-xs text-gray-500">In House</p>
                            )}
                            {value.market && (
                              <p className="text-xs text-gray-500">
                                Market Place
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="text-5xl font-bold text-blue-600">
                          {value.new +
                            value.scheduled +
                            value.completed +
                            value.selected}
                        </div>
                      </div>
                    </div>
                  ) : (
                    /* Add Round Card */
                    <div
                      className="border border-gray-200 rounded-lg py-3 px-4 h-64 flex flex-col gap-2 hover:shadow-md transition-shadow cursor-pointer border-dashed hover:border-blue-400 bg-blue-50 group"
                      onClick={() => addRound()}
                    >
                      <div className="flex flex-col items-center justify-center h-full gap-3">
                        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                          <div className="text-2xl font-semibold text-blue-600">
                            +
                          </div>
                        </div>
                        <div className="text-center">
                          <div className="text-sm font-semibold text-gray-900 group-hover:text-blue-600">
                            Add Round
                          </div>
                          <p className="text-xs text-gray-500 mt-1">
                            Create a new interview round
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default JdRounds;
